import Vue from 'vue'

export default {
  create: function (type) {
    let resource = Vue.axiosFactory.create({baseURL: 'app/sites/' + type})
    let generalResource = Vue.axiosFactory.create({baseURL: 'app/sites/'})

    return {
      findById(siteId, projectId) {
        return resource({method: 'get', url: `${projectId}/${siteId}`})
      },
      findByDomain(domain) {
        return resource({method: 'get', url: `find_by_domain/${domain}`})
      },
      update(site) {
        return resource({method: 'put', url: site.project + '/' + site._id, data: site})
      },
      remove(site) {
        return resource({method: 'post', url: site._id + '/handle_remove'})
      },
      create(site, projectId) {
        let url = type === 'business' ? projectId + '/create_with_keywords' : projectId
        return resource({method: 'post', url, data: site})
      },
      getFuturePBNsCount() {
        return resource({method: 'get', url: 'future_pbns'})
      },
      getSitesCount() {
        return resource({method: 'get', url: 'count'})
      },
      testDomain(domain, category) {
        return generalResource({method: 'post', url: 'test_domain', data: {domain, category}})
      },
      reuploadByDomains(domains) {
        return generalResource({method: 'post', url: 'reupload_by_domains', data: {domains}})
      },
      releaseSitesChangeInProgress(domains) {
        return generalResource({method: 'post', url: 'release_change_in_progress_by_domains', data: {domains}})
      },
      getRankingStatsBySite() {
        return resource({method: 'get', url: 'get_ranking_stats_by_site'}).then(({statsByDomain}) => statsByDomain)
      },
      listKeywords(siteId) {
        return resource({method: 'get', url: siteId + '/keywords'})
      },
      listOriginalKeywords(siteId) {
        return resource({method: 'get', url: siteId + '/original_keywords'})
      },
      listHeaders(categories) {
        return resource({method: 'get', url: '/list_headers', params: {categories}})
      },
      listThemes() {
        return resource({method: 'get', url: '/list_themes'})
      },
      listHeaderCategories () {
        return resource({method: 'get', url: '/list_header_categories'})
      },
      checkLocationBlacklisted (location) {
        return resource({method: 'get', url: '/check_location_blacklisted', params: {location}})
      },
      validateUrl (websiteUrl) {
        return generalResource({method: 'get', url: '/validate_url', params: {websiteUrl}})
      },
      validateRedirectedWebsite (websiteUrl) {
        return resource({method: 'get', url: '/validate_redirected_website', params: {websiteUrl}})
      },
      listNoneAdactiveSites () {
        return resource({method: 'get', url: '/list_none_adactive', params: {location}})
      },
      listByAccount (accountId) {
        return resource({method: 'get', url: '/list_for_account', params: {accountId}})
      }
    }
  }
}
